import { motion } from "framer-motion";

const testimonials = [
  { quote: "Comecei a fazer os exercícios numa noite em que não conseguia dormir. Ao fim de três páginas, percebi que já sabia a resposta — só nunca tinha tido coragem de a escrever.", name: "Mariana C.", role: "Lisboa" },
  { quote: "Não é um livro para ler de uma vez. É para conviveres com ele. Voltei ao capítulo IX três vezes. Em cada uma doeu menos. Em cada uma ficou mais claro.", name: "Inês R.", role: "Porto" },
  { quote: "A Anabela escreve como quem sussurra. Sem pressa, sem fórmulas. Senti-me acompanhada — não corrigida.", name: "Sofia M.", role: "Coimbra" },
  { quote: "Comprei à pressa e deixei-o na mesa de cabeceira durante semanas. Quando finalmente o abri, já era tarde de mais para fingir. E ainda bem.", name: "Joana T.", role: "Braga" },
];

export default function Testimonials() {
  return (
    <section
      id="testemunhos"
      data-testid="testimonials-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream"
    >
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14"
        >
          <div className="md:col-span-3">
            <span className="section-num">08 · Quem já leu</span>
          </div>
          <div className="md:col-span-9">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.15]">
              Palavras de quem
              <br />
              <span className="font-serif-display text-orange normal-case lowercase">também não conseguia</span>
              <br />
              continuar igual.
            </h2>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              data-testid={`testimonial-${i}`}
              className="card-soft p-8 md:p-10"
            >
              <span className="text-orange font-serif-display text-4xl leading-none block mb-4">"</span>
              <blockquote className="font-serif-display text-xl md:text-2xl text-ink leading-snug mb-6">
                {t.quote}
              </blockquote>
              <figcaption className="flex items-center gap-3 pt-4 border-t border-line">
                <span className="smallcaps text-ink">{t.name}</span>
                <span className="w-1 h-1 rounded-full bg-orange" />
                <span className="smallcaps">{t.role}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
